import React from "react";
import  './../PrePayment.scss'
import {ThemeProvider} from "@material-ui/core";
import {PrePaymentThemeHolder} from "../theme/PrePaymentThemeHolder";
import {PrePaymentWrapperHeader} from "./PrePaymentWrapperHeader";
import {LoanData} from "../../../../loan-details/model/LoanData";
import {PrePaymentWrapperFooter} from "./PrePaymentWrapperFooter";
import {PrePaymentWrapperIcons} from "./PrePaymentWrapperIcons";
import {toPublicUrl} from "src/modules/util/UrlUtil";

interface Props {
    loan: LoanData;
}


export class PrePaymentAchWrapper extends React.Component<Props> {

    private static readonly theme = PrePaymentThemeHolder.THEME;

    render() {
        return <>
            <div id="payment_page">
                <PrePaymentWrapperHeader>
                    ACH payments are powered by Stripe Financial Connections.
                </PrePaymentWrapperHeader>
                <PrePaymentWrapperIcons>
                    <img src={toPublicUrl('/images/icons/stripe.svg')} alt={'Stripe'}/>
                </PrePaymentWrapperIcons>
                <div id="payment_page_form_wrapper">
                    <ThemeProvider theme={PrePaymentAchWrapper.theme}>
                        {this.props.children}
                    </ThemeProvider>
                </div>
                <PrePaymentWrapperFooter loan={this.props.loan}/>
            </div>
        </>;
    }

}